// src/dexieDB.js
import Dexie from 'dexie';

const db = new Dexie('LocationDB');

db.version(1).stores({
  // جدول استان‌ها: primary key = id
  states: 'id, name',
  // جدول شهرها: primary key = cityId، ایندکس stateId برای جستجو بر اساس استان
  cities: 'cityId, stateId, name'
});
export default db;